const content = `<b style="font-size: 2.2rem;">Datenschutzerklärung zum Kontaktformular</b>

Wir freuen uns über Ihr Interesse an manny+nanny | DIE BABYSITTER AGENTUR, einem Geschäftsbereich der Lenssen GmbH. Wenn Sie unser Kontaktformular nutzen, verarbeiten wir Ihre personenbezogenen Daten (z. B. Ihre E-Mail-Adresse und ggf. Ihre Telefonnummer), um Ihre Nachricht zu bearbeiten und Sie bei Bedarf zu kontaktieren. Dabei ist es erforderlich, dass Sie unseren verlinkten Allgemeinen Geschäftsbedingungen (AGB) sowie unserer verlinkten Datenschutzerklärung zustimmen.

Die Einwilligung zur Speicherung Ihrer E-Mail-Adresse und gegebenenfalls Ihrer Telefonnummer können Sie jederzeit mit Wirkung für die Zukunft widerrufen. Ausführliche Informationen zur Datenverarbeitung und zu Ihren Rechten gemäß der DSGVO finden Sie in unserer vollständigen Datenschutzerklärung.
`

function PrivacyPolicyContactDe(props) {
    return (
        <div className="text_2_black" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: content}}/>
    );
}

export default PrivacyPolicyContactDe;
